module.exports = "<div class=\"container d-flex flex-column offset-lg-1 col-lg-10\">\n  <h2>Money and banking</h2>\n  <p>Money exchange offices (called Kantor in Polish) are located in train stations, airports and around city centers of major Polish cities. Cash machines (called Bankomat in Polish) are also easy to find in banks, train stations, airports and shopping centers.</p>\n </div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/money-banking/money-banking.component.html
// module id = ../../../../../src/app/money-banking/money-banking.component.html
// module chunks = main